import React, { useState } from "react"
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import { updateCardStatus } from "store/actions/cardsAction"
import Switch from "../../../components/Shared/Switch"

const ChangeAssetsStatusModal = ({ isOpen, toggle, trigger, selected }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [idCardStatus, setIdCardStatus] = useState(
    selected?.id_card_status === 2 || selected?.id_card_status === 3
  )
  const [uniformStatus, setUniformStatus] = useState(
    selected?.uniform_status === 2 || selected?.uniform_status === 3
  )
  const [isSubmitting, setIsSubmitting] = useState(false)
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const handleSubmit = () => {
    setIsSubmitting(true)
    const payload = {
      id_card_uuid: selected?.uuid,
      id_card_status: idCardStatus,
      uniform_status: uniformStatus,
    }

    dispatch(updateCardStatus(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload || {}
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          trigger()
        } else {
          dispatch(
            showAlert({ text: message || "An error occurred", type: "error" })
          )
        }
      })
      .catch(err => {
        console.error("Submission error:", err)
        dispatch(showAlert({ text: "Unexpected error", type: "error" }))
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{t("Update Asset Status")}</ModalHeader>
      <ModalBody>
        <Row>
          <h5 className={"mb-3"}>
            {t("National ID:")} {selected?.national_id}
          </h5>
          <h5 className={"mb-3"}>
            {t("ID Card Number:")} {selected?.id_card_serial_number}
          </h5>
          <div className="border rounded p-3">
            <Col xs="12" className="mb-3">
              <Switch
                onValue={t("ID Card Dispatched")}
                offValue={t("ID Card Dispatched")}
                isChecked={idCardStatus}
                onClick={() =>
                  setIdCardStatus(!idCardStatus)
                }
                onClickHandler={e => console.log(e)}
                onChange={e => {
                  setIdCardStatus(e.target.checked)
                }}
                disabled={
                  selected?.id_card_status === 2 ||
                  selected?.id_card_status === 3
                }
                layoutMode={layoutMode}
              />
            </Col>
            <Col xs="12">
              <Switch
                onValue={t("Uniform Dispatched")}
                offValue={t("Uniform Dispatched")}
                isChecked={uniformStatus}
                onClickHandler={e => console.log(e)}
                onClick={() =>
                  setUniformStatus(!uniformStatus)
                }
                onChange={e => {
                  setUniformStatus(e.target.checked)
                }}
                disabled={
                  selected?.uniform_status === 2 ||
                  selected?.uniform_status === 3
                }
                layoutMode={layoutMode}
              />
            </Col>
          </div>
        </Row>
      </ModalBody>

      <ModalFooter>
        <div className="d-flex flex-wrap gap-2">
          <button
            type="button"
            className="main_btn disabled-button fit_content px-4"
            onClick={toggle}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="main_btn fit_content px-4"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {t("Save")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default ChangeAssetsStatusModal
